import { GAME_ID } from '../../data/constants';

/**
 * create a generic action object that is tied to the eReader game ID.
 * @param {string} type an action type
 * @param {any} payload data to pass to the reducer
 * @returns {object} action object
 */
const createAction = (type, payload = {}) => ({
  gameId: GAME_ID,
  type,
  payload,
});

export default createAction;
